import logger from 'conversations/utils/logger'
import { IpcChannel } from 'shared/ipc/IpcChannel'

import { getIpcService } from './ipc'

export const registerNavigationListeners = () => {
  const ipcService = getIpcService()

  ipcService.on<string, void>(IpcChannel.EXTERNAL_OPEN_URL, (path?: string) => {
    if (!path || path?.indexOf('/conversations') === -1) {
      logger.warn(`Attempted to open unsupported path: ${path}`)
      return Promise.reject(new Error(`Attempted to open unsupported path: ${path}`))
    }

    logger.info(`Received request to open path ${path}`)
    window.location.href = `#${path}`
    return Promise.resolve()
  })
}
